import Label from "components/Label/Label";
import React, { useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import useFetch from "hooks/useFetch";
import ErrorModal from "components/Modal/errorModal";
import SuccessModal from "components/Modal/successModal";
import config from "config.json";

const SendVerificationCode = () => {
  const url = config.backend_url;
  const [formData, setFormData] = useState({});
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { data, error, isLoading, fetchData } = useFetch(
    "POST",
    `${url}/authe/request_pass`,
    formData,
    { "Content-Type": "application/json" }
  );

  const handleSendVerification = () => {
    // Resetear modales antes de cada solicitud
    setIsErrorModalOpen(false);
    setIsSuccessModalOpen(false);
    setErrorMessage("");

    // Enviar la solicitud
    fetchData();
  };

  useEffect(() => {
    if (data && (data as any).code === "200") {
      // Si la respuesta es exitosa
      setIsErrorModalOpen(false); // Asegurarse de cerrar el modal de error
      setIsSuccessModalOpen(true); // Abrir el modal de éxito
      const usuario = formData as any;
      sessionStorage.setItem("recover-mail", usuario.mail);
    } else if (error) {
      // Si ocurre un error
      setIsSuccessModalOpen(false); // Asegurarse de cerrar el modal de éxito
      setErrorMessage(
        "No se pudo enviar el código de verificación. Por favor intente nuevamente."
      );
      setIsErrorModalOpen(true); // Abrir el modal de error
    }
  }, [data, error]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCloseSuccessModal = () => {
    setIsSuccessModalOpen(false);
    window.location.href = "/forgot-pass";
  };

  return (
    <div className="space-y-6 sm:space-y-8 pt-5 pb-12 flex justify-center pl-10 pr-10">
      <SuccessModal
        isModalOpen={isSuccessModalOpen}
        handleModalClose={handleCloseSuccessModal}
        title="Se envió un código de verificación"
        message="Por favor verifique su correo para continuar con el proceso de recuperación de contraseña"
      />
      <ErrorModal
        isModalOpen={isErrorModalOpen}
        handleModalClose={() => setIsErrorModalOpen(false)}
        message={errorMessage}
      />
      <div className="space-y-6 sm:space-y-8">
        <h2 className="text-3xl font-semibold text-center">
          Recuperar contraseña
        </h2>

        <div className="max-w-xl space-y-6">
          <div>
            <Label>&nbsp;Ingrese su mail:</Label>
            <input
              type="email"
              name="mail"
              autoComplete="email"
              required={true}
              onChange={handleInputChange}
              className="block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 rounded-2xl text-sm font-normal h-11 px-4 py-3 mt-1.5"
            />
          </div>
          <div className="max-w-xl space-y-6 flex justify-center">
            <p className="text-sm text-center">
              Enviaremos un código de verificación a su correo para recuperar su
              contraseña
            </p>
          </div>
          <div className="pt-2 flex justify-center">
            <ButtonPrimary disabled={isLoading} onClick={handleSendVerification}>
              Enviar
            </ButtonPrimary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendVerificationCode;